import React from "react";
import Logo from '../../media/images/raidhiveLogo-nobg.png';
import { StyledFooter } from "./Footer.styled";
import { Flex } from "../styles/Flex.styled";
import { Container } from "../Header/Header.styled";
export const Footer = () => {
    return (
        <StyledFooter>
            <Container>
                <img src={Logo} alt='' />

                <Flex>                    
                    <ul>
                        <li>RaidHive Team</li>
                        <li>raidhiveteam@gmail.com</li>
                    </ul>
                    <ul>
                        <li>FAQ</li>
                        <li>* RaidLive- Live events.</li>
                        {/* Live events */}
                        <li>* RaidTask- Tasks given for RaidLive event-Online/Offline</li>
                        {/* Tasks given for RaidLive event */}
                        <li>* RaidCommunity- Community select the upcoming RaidTask based on poll.</li>
                        {/* Join communities listed below */}
                    </ul>
                    {/* <SocialIcons/> */}                                    
                    
                </Flex>                    
                <p style={{textAlign:'center', marginTop:'2em'}}>&copy; 2022 RaidHive. All rights reserved</p>
            </Container>
        </StyledFooter>
    );
}